function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * AAA IDP delivery method
 * 
 */
import React from 'react';
import { connect } from 'react-redux';
import { deliveryInt, deliveryMethod, deliveryPickUpStoreRequiredAttribute, deliveryPickupPersonRequiredAttribute, deliveryAddressRequiredAttribute, postage } from '../../actions/index';
import { DELIVERY_METHOD_POSTAGE, DELIVERY_METHOD_PICK_UP_IN_STORE, STORES_API, POSTAGE } from '../../data/Data';
import { portalFetch } from '../../utils/portalFetch';
import './DeliveryMethod.scss';
import DeliveryMethodPostage from '../delivery-address/DeliveryAddress';
import DeliveryMethodPickUpInStore from '../delivery-method-pick-up-in-store/DeliveryMethodPickUpInStore';
import ErrorMessage from '../error-message/ErrorMessage';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export class DeliveryMethod extends React.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "handleSelectionChange", value => {
      const {
        deliveryInt,
        setDeliveryMethod,
        setPostage,
        setDeliveryPickUpStoreRequiredAttribute,
        setDeliveryPickupPersonRequiredAttribute,
        setDeliveryAddressRequiredAttribute
      } = this.props;
      setDeliveryMethod(value);
      if (value === DELIVERY_METHOD_PICK_UP_IN_STORE.value) {
        setPostage(POSTAGE[2]);
        deliveryInt('Australian');
        setDeliveryPickUpStoreRequiredAttribute(true);
        setDeliveryPickupPersonRequiredAttribute(true);
        setDeliveryAddressRequiredAttribute(false);
      } else {
        setPostage(POSTAGE[0]);
        setDeliveryPickUpStoreRequiredAttribute(false);
        setDeliveryPickupPersonRequiredAttribute(false);
        setDeliveryAddressRequiredAttribute(true);
      }
    });
    /**
     * onFocus
     */
    _defineProperty(this, "onFocus", focus => {
      this.handleSelectionChange(focus);
      this.setState({
        focus
      });
    });
    /**
     * onBlur
     */
    _defineProperty(this, "onBlur", () => {
      this.setState({
        focus: ''
      });
    });
    /**
     * Select Postage / Pick up in-store
     */
    _defineProperty(this, "select", value => {
      this.handleSelectionChange(value);
    });
    _defineProperty(this, "getStores", () => {
      const {
        application
      } = this.props;
      const {
        club
      } = application;
      portalFetch(`${STORES_API}/clubs/${club.id}/stores`).then(response => {
        if (response.status >= 400) {
          const message = `HTTP status code: ${response.status}`;
          const err = new Error(message);
          response.json().then(result => console.warn(result));
          throw err;
        } else {
          return response.json();
        }
      }).then(results => this.success(results)).catch(error => this.error(error));
    });
    _defineProperty(this, "success", result => {
      if (!result) {
        this.handleSelectionChange('Postage');
        return null;
      }
      if (result.errors && result.message || !result.data) {
        const message = result.message ? result.message : 'No data returned from API';
        this.error(new Error(message));
        this.handleSelectionChange('Postage');
        return;
      }
      if (result.data.length === 0) {
        this.handleSelectionChange('Postage');
      }
      this.setState({
        clubStores: result.data
      });
    });
    _defineProperty(this, "error", error => {
      const {
        bugsnagClient,
        jest
      } = this.props;
      if (jest) return null;
      console.warn(error);
      this.setState({
        error: true,
        submitted: false,
        submitting: false
      });
      bugsnagClient.notify(error);
    });
    this.state = {
      focus: '',
      clubStores: []
    };
  }
  componentDidMount() {
    this.getStores();
  }
  render() {
    const {
      deliveryMethod
    } = this.props;
    let errorMessage = deliveryMethod.error ? 'A delivery method must be selected.' : '';
    let buttons = [];
    const options = [{
      default: true,
      checked: deliveryMethod.value === DELIVERY_METHOD_POSTAGE.value,
      label: DELIVERY_METHOD_POSTAGE.label,
      description: DELIVERY_METHOD_POSTAGE.description,
      value: DELIVERY_METHOD_POSTAGE.value
    }, {
      default: false,
      checked: deliveryMethod.value === DELIVERY_METHOD_PICK_UP_IN_STORE.value,
      label: DELIVERY_METHOD_PICK_UP_IN_STORE.label,
      description: DELIVERY_METHOD_PICK_UP_IN_STORE.description,
      value: DELIVERY_METHOD_PICK_UP_IN_STORE.value
    }];
    for (let i = 0; i < options.length; i++) {
      const option = options[i];
      const highlight = option.checked ? ' highlight' : '';
      let temporaryNotice = null;
      if (option.value === DELIVERY_METHOD_PICK_UP_IN_STORE.value) {
        temporaryNotice = /*#__PURE__*/_jsx("div", {
          className: "notice",
          children: "In-store pickup has a limited number of pickup locations"
        });
      }
      buttons.push(/*#__PURE__*/_jsxs("div", {
        className: 'radiobutton-container' + highlight,
        tabIndex: "0",
        onBlur: () => this.onBlur,
        onFocus: () => this.onFocus(option.value),
        children: [temporaryNotice, /*#__PURE__*/_jsx("input", {
          id: option.value,
          className: "radio-button-hidden",
          type: "radio",
          checked: option.checked,
          value: option.value,
          onChange: () => this.select(option.value)
        }), /*#__PURE__*/_jsxs("label", {
          htmlFor: option.value,
          children: [/*#__PURE__*/_jsx("div", {
            className: "radio-display",
            children: /*#__PURE__*/_jsx("div", {
              className: `inner${highlight}`
            })
          }), /*#__PURE__*/_jsx("span", {
            children: option.label
          })]
        }), /*#__PURE__*/_jsx("span", {
          dangerouslySetInnerHTML: {
            __html: option.description
          }
        })]
      }, option.value));
    }
    if (this.state.clubStores.length > 0 && buttons.length > 0) {
      return /*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx("div", {
          className: "form-element-container DeliveryMethod",
          children: /*#__PURE__*/_jsxs("div", {
            className: "delivery-options",
            children: [/*#__PURE__*/_jsx("div", {
              className: "label title",
              children: "Select delivery method:"
            }), /*#__PURE__*/_jsx("div", {
              className: "radio-buttons",
              children: buttons
            })]
          })
        }), deliveryMethod.value === 'Postage' && /*#__PURE__*/_jsx(DeliveryMethodPostage, {}), deliveryMethod.value === 'PickUpInStore' && /*#__PURE__*/_jsx(DeliveryMethodPickUpInStore, {
          clubStores: this.state.clubStores
        }), /*#__PURE__*/_jsx(ErrorMessage, {
          message: errorMessage,
          error: deliveryMethod.error
        })]
      });
    } else {
      return /*#__PURE__*/_jsx(DeliveryMethodPostage, {});
    }
  }
}
_defineProperty(DeliveryMethod, "defaultProps", {
  deliveryMethod: {
    error: false,
    required: true,
    valid: true,
    value: ''
  }
});
const mapStateToProps = ({
  application,
  deliveryMethod
}) => {
  return {
    application,
    deliveryMethod
  };
};
const mapDispatchToProps = dispatch => {
  return {
    deliveryInt: value => {
      dispatch(deliveryInt(value));
    },
    setDeliveryMethod: value => {
      dispatch(deliveryMethod(value));
    },
    setDeliveryPickUpStoreRequiredAttribute: required => {
      dispatch(deliveryPickUpStoreRequiredAttribute(required));
    },
    setDeliveryPickupPersonRequiredAttribute: required => {
      dispatch(deliveryPickupPersonRequiredAttribute(required));
    },
    setDeliveryAddressRequiredAttribute: required => {
      dispatch(deliveryAddressRequiredAttribute(required));
    },
    setPostage: value => {
      dispatch(postage(value));
    }
  };
};
const VisibleDeliveryMethod = connect(mapStateToProps, mapDispatchToProps)(DeliveryMethod);
export default VisibleDeliveryMethod;